<template>
  <div id="contenedor-eliminar-contrato-superintendente">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Superintendente </v-card-title>
      <v-card-text>
        <span class="secondary--text"> ¿Desea eliminar al superintedente? </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixRemoverSuperintendente"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixSuperintendenteContrato from './mixSuperintendenteContrato';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarSuperintendenteContrato',
  mixins: [mixSuperintendenteContrato],
  props: {
    superintendenteEliminar: Object,
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
